export default import.meta.ROLLUP_FILE_URL_FzmteDzgi4FKENZOk9tB4A